/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiKeyCreatedResponse } from '../models';
// @ts-ignore
import type { ApiKeyResponse } from '../models';
// @ts-ignore
import type { ApiKeyStatus } from '../models';
// @ts-ignore
import type { CreateApiKeyRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { PagedApiKeyResponse } from '../models';
// @ts-ignore
import type { UpdateApiKeyRequest } from '../models';
/**
 * APIKeysApi - axios parameter creator
 * @export
 */
export const APIKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new API key for a partner
         * @summary Create a new API key
         * @param {string} partnerId 
         * @param {CreateApiKeyRequest} createApiKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeyV1: async (partnerId: string, createApiKeyRequest: CreateApiKeyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('createApiKeyV1', 'partnerId', partnerId)
            // verify required parameter 'createApiKeyRequest' is not null or undefined
            assertParamExists('createApiKeyV1', 'createApiKeyRequest', createApiKeyRequest)
            const localVarPath = `/api/v1/partners/{partnerId}/api-keys`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createApiKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete (revoke) an API key
         * @summary Delete an API key
         * @param {string} partnerId 
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyV1: async (partnerId: string, apiKeyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('deleteApiKeyV1', 'partnerId', partnerId)
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('deleteApiKeyV1', 'apiKeyId', apiKeyId)
            const localVarPath = `/api/v1/partners/{partnerId}/api-keys/{apiKeyId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"apiKeyId"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details of a specific API key
         * @summary Get API key details
         * @param {string} partnerId 
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyV1: async (partnerId: string, apiKeyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getApiKeyV1', 'partnerId', partnerId)
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('getApiKeyV1', 'apiKeyId', apiKeyId)
            const localVarPath = `/api/v1/partners/{partnerId}/api-keys/{apiKeyId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"apiKeyId"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all API keys for a partner
         * @summary List API keys for a partner
         * @param {string} partnerId 
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {ApiKeyStatus} [status] 
         * @param {string} [sort] 
         * @param {ListApiKeysV1DirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysV1: async (partnerId: string, page?: number, size?: number, status?: ApiKeyStatus, sort?: string, direction?: ListApiKeysV1DirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('listApiKeysV1', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partners/{partnerId}/api-keys`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an API key\'s properties
         * @summary Update an API key
         * @param {string} partnerId 
         * @param {string} apiKeyId 
         * @param {UpdateApiKeyRequest} updateApiKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeyV1: async (partnerId: string, apiKeyId: string, updateApiKeyRequest: UpdateApiKeyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('updateApiKeyV1', 'partnerId', partnerId)
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('updateApiKeyV1', 'apiKeyId', apiKeyId)
            // verify required parameter 'updateApiKeyRequest' is not null or undefined
            assertParamExists('updateApiKeyV1', 'updateApiKeyRequest', updateApiKeyRequest)
            const localVarPath = `/api/v1/partners/{partnerId}/api-keys/{apiKeyId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"apiKeyId"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateApiKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * APIKeysApi - functional programming interface
 * @export
 */
export const APIKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = APIKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new API key for a partner
         * @summary Create a new API key
         * @param {string} partnerId 
         * @param {CreateApiKeyRequest} createApiKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createApiKeyV1(partnerId: string, createApiKeyRequest: CreateApiKeyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeyCreatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createApiKeyV1(partnerId, createApiKeyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.createApiKeyV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete (revoke) an API key
         * @summary Delete an API key
         * @param {string} partnerId 
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApiKeyV1(partnerId: string, apiKeyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApiKeyV1(partnerId, apiKeyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.deleteApiKeyV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get details of a specific API key
         * @summary Get API key details
         * @param {string} partnerId 
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiKeyV1(partnerId: string, apiKeyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiKeyV1(partnerId, apiKeyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.getApiKeyV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all API keys for a partner
         * @summary List API keys for a partner
         * @param {string} partnerId 
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {ApiKeyStatus} [status] 
         * @param {string} [sort] 
         * @param {ListApiKeysV1DirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listApiKeysV1(partnerId: string, page?: number, size?: number, status?: ApiKeyStatus, sort?: string, direction?: ListApiKeysV1DirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedApiKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listApiKeysV1(partnerId, page, size, status, sort, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.listApiKeysV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an API key\'s properties
         * @summary Update an API key
         * @param {string} partnerId 
         * @param {string} apiKeyId 
         * @param {UpdateApiKeyRequest} updateApiKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApiKeyV1(partnerId: string, apiKeyId: string, updateApiKeyRequest: UpdateApiKeyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApiKeyV1(partnerId, apiKeyId, updateApiKeyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.updateApiKeyV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * APIKeysApi - factory interface
 * @export
 */
export const APIKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = APIKeysApiFp(configuration)
    return {
        /**
         * Create a new API key for a partner
         * @summary Create a new API key
         * @param {string} partnerId 
         * @param {CreateApiKeyRequest} createApiKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeyV1(partnerId: string, createApiKeyRequest: CreateApiKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyCreatedResponse> {
            return localVarFp.createApiKeyV1(partnerId, createApiKeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete (revoke) an API key
         * @summary Delete an API key
         * @param {string} partnerId 
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyV1(partnerId: string, apiKeyId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteApiKeyV1(partnerId, apiKeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get details of a specific API key
         * @summary Get API key details
         * @param {string} partnerId 
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyV1(partnerId: string, apiKeyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyResponse> {
            return localVarFp.getApiKeyV1(partnerId, apiKeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all API keys for a partner
         * @summary List API keys for a partner
         * @param {string} partnerId 
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {ApiKeyStatus} [status] 
         * @param {string} [sort] 
         * @param {ListApiKeysV1DirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysV1(partnerId: string, page?: number, size?: number, status?: ApiKeyStatus, sort?: string, direction?: ListApiKeysV1DirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<PagedApiKeyResponse> {
            return localVarFp.listApiKeysV1(partnerId, page, size, status, sort, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an API key\'s properties
         * @summary Update an API key
         * @param {string} partnerId 
         * @param {string} apiKeyId 
         * @param {UpdateApiKeyRequest} updateApiKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeyV1(partnerId: string, apiKeyId: string, updateApiKeyRequest: UpdateApiKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyResponse> {
            return localVarFp.updateApiKeyV1(partnerId, apiKeyId, updateApiKeyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * APIKeysApi - object-oriented interface
 * @export
 * @class APIKeysApi
 * @extends {BaseAPI}
 */
export class APIKeysApi extends BaseAPI {
    /**
     * Create a new API key for a partner
     * @summary Create a new API key
     * @param {string} partnerId 
     * @param {CreateApiKeyRequest} createApiKeyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public createApiKeyV1(partnerId: string, createApiKeyRequest: CreateApiKeyRequest, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).createApiKeyV1(partnerId, createApiKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete (revoke) an API key
     * @summary Delete an API key
     * @param {string} partnerId 
     * @param {string} apiKeyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public deleteApiKeyV1(partnerId: string, apiKeyId: string, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).deleteApiKeyV1(partnerId, apiKeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details of a specific API key
     * @summary Get API key details
     * @param {string} partnerId 
     * @param {string} apiKeyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public getApiKeyV1(partnerId: string, apiKeyId: string, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).getApiKeyV1(partnerId, apiKeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all API keys for a partner
     * @summary List API keys for a partner
     * @param {string} partnerId 
     * @param {number} [page] The zero-based index of the page of results to return.
     * @param {number} [size] The maximum number of results to return in a page.
     * @param {ApiKeyStatus} [status] 
     * @param {string} [sort] 
     * @param {ListApiKeysV1DirectionEnum} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public listApiKeysV1(partnerId: string, page?: number, size?: number, status?: ApiKeyStatus, sort?: string, direction?: ListApiKeysV1DirectionEnum, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).listApiKeysV1(partnerId, page, size, status, sort, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an API key\'s properties
     * @summary Update an API key
     * @param {string} partnerId 
     * @param {string} apiKeyId 
     * @param {UpdateApiKeyRequest} updateApiKeyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public updateApiKeyV1(partnerId: string, apiKeyId: string, updateApiKeyRequest: UpdateApiKeyRequest, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).updateApiKeyV1(partnerId, apiKeyId, updateApiKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListApiKeysV1DirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type ListApiKeysV1DirectionEnum = typeof ListApiKeysV1DirectionEnum[keyof typeof ListApiKeysV1DirectionEnum];
